import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./FilterModal.module.css";

export default function FilterModal({
                                        isOpen,
                                        onClose,
                                        sortOptions = [],
                                        sortBy,
                                        direction,
                                        onChangeSort
                                    }) {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [onClose]);

    if (!isOpen) return null;

    return createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <h5 className="mb-3">Сортировка</h5>
                <div className="mb-2">
                    {sortOptions.map((opt) => (
                        <label
                            key={opt.value}
                            className={`${styles.radioOption} d-block mb-2`}
                        >
                            <input
                                type="radio"
                                name="sortBy"
                                value={opt.value}
                                checked={sortBy === opt.value}
                                onChange={() => onChangeSort(opt.value, direction)}
                                className={`me-2`}
                            />
                            {opt.label}
                        </label>
                    ))}
                </div>

                <div className="mt-3">
                    <label className="me-3">
                        <input
                            type="radio"
                            name="direction"
                            value="asc"
                            checked={direction === "asc"}
                            onChange={() => onChangeSort(sortBy, "asc")}
                        />{" "}
                        По возрастанию
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="direction"
                            value="desc"
                            checked={direction === "desc"}
                            onChange={() => onChangeSort(sortBy, "desc")}
                        />{" "}
                        По убыванию
                    </label>
                </div>

                <div className="mt-4 text-end">
                    <button className={`service-btn w-100`} onClick={onClose}>
                        Закрыть
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
